module.exports = __webpack_public_path__ + "img/load-verification.a992b176.svg";